<!-- Pleine page (/sales/products) ou MODALE de choix d'article (vente, commande, remise) : `dialogRef` seul les distingue. -->
@if (!dialogData) {
  <app-menu-common url="sales"></app-menu-common>
}

<div class="products-page" [class.in-dialog]="!!dialogRef">

  <!-- Titre, filtres et actions sont frères d'un seul flex-wrap : ils passent à la ligne un par un, sans se comprimer. -->
  <div class="toolbar-card" [formGroup]="formGroup">

    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">inventory_2</mat-icon>
      <span>Produits</span>
    </div>

    <div class="filter-item">
      <label class="filter-label" [title]="dialogRef ? 'Aller droit à un produit par son numéro : Tab l\'affiche, l\'icône ouvre sa fiche, Entrée le renvoie à l\'appelant' : 'Aller droit à un produit par son numéro : Tab l\'affiche, Entrée ou l\'icône ouvre sa fiche'">Id produit</label>
      <smart-input #productIdNav width="118px" type="number" placeholder="N°" icon="link"
        iconClass="custom-icon-button primary" [iconHref]="productIdHref" iconTarget="_blank"
        (valueChange)="onProductIdChange($event)" (blurred)="onProductIdBlur($event)"
        (iconClicked)="onProductIdLinkClick()" (enterPressed)="onProductIdValidate($event)" />
    </div>

    <div class="filter-item">
      <label class="filter-label">Nom</label>
      <smart-input width="260px" formControlName="name" autofocus initialValue="" placeholder="Rechercher par nom"
        icon="close" iconClass="custom-icon-button error" (enterPressed)="onSearch()"
        (iconClicked)="formGroup.get('name')?.setValue('')" />
    </div>

    <div class="filter-item">
      <label class="filter-label" title="Code-barres d'un conditionnement actif du produit, en entier ou en partie">Code-barres</label>
      <smart-input width="150px" formControlName="ean" initialValue="" placeholder="EAN"
        icon="close" iconClass="custom-icon-button error" (enterPressed)="onSearch()"
        (iconClicked)="formGroup.get('ean')?.setValue('')" />
    </div>

    <div class="filter-item">
      <label class="filter-label" title="Référence fournisseur du produit, en entier ou en partie">Réf. fournisseur</label>
      <smart-input width="150px" formControlName="refsup" initialValue="" placeholder="Réf."
        icon="close" iconClass="custom-icon-button error" (enterPressed)="onSearch()"
        (iconClicked)="formGroup.get('refsup')?.setValue('')" />
    </div>

    <div class="filter-item partner-filter">
      <label class="filter-label">Fabricant</label>
      <!-- (input) : la frappe du nom de fabricant, avant tout choix, coupe déjà la recherche en vol -->
      <app-search-partner [currentPartner]="searchmanuf" [showSelectionInInput]="true" width="250px" id="search-manuf"
        (partnerChange)="manufactureChange($event)" (input)="dropPendingSearch()" [roles]="[constants.PARTNER_ROLE_MANUFACTURER]"></app-search-partner>
    </div>

    <div class="filter-item">
      <label class="filter-label" title="Prix de vente TTC du produit">Prix TTC</label>
      <div class="range-field">
        <input #minPriceInput class="range-input" type="number" placeholder="Min"
          formControlName="minprice" (focus)="minPriceInput.select()" (change)="onMinPriceChange()">
        <span class="range-sep">—</span>
        <input #maxPriceInput class="range-input" type="number" placeholder="Max"
          formControlName="maxprice" (focus)="maxPriceInput.select()" (change)="onMaxPriceChange()">
      </div>
    </div>

    <!-- Champs libres (cufs) déclarés « sélecteur » : leur nombre et leur type viennent de
         la base, la feuille les ramène au gabarit des autres filtres. -->
    <div class="filter-item cuf-filter">
      <app-cuf [cufsStructure]="cufsStructure" [cufGroup]="icuf" [mode]="'selector'" [inline]="false"></app-cuf>
    </div>

    <!-- Cases à trois états (Oui → Non → Tous) : « Non » retrouve les articles que la vente ne montre pas. -->
    <div class="filter-item">
      <label class="filter-label">Vendable</label>
      <button type="button" class="flag-filter" [class.state-yes]="formGroup.value.is_sold === true" [class.state-no]="formGroup.value.is_sold === false"
        [attr.aria-label]="'Vendable : ' + flagText(formGroup.value.is_sold)" [matTooltip]="SOLD_HINT" matTooltipClass="tooltip-multiline"
        (click)="cycleFlag('is_sold')">
        <mat-icon>{{ flagIcon(formGroup.value.is_sold) }}</mat-icon><span>{{ flagText(formGroup.value.is_sold) }}</span>
      </button>
    </div>

    <div class="filter-item">
      <label class="filter-label">Achetable</label>
      <button type="button" class="flag-filter" [class.state-yes]="formGroup.value.is_purchased === true" [class.state-no]="formGroup.value.is_purchased === false"
        [attr.aria-label]="'Achetable : ' + flagText(formGroup.value.is_purchased)" [matTooltip]="PURCHASED_HINT" matTooltipClass="tooltip-multiline"
        (click)="cycleFlag('is_purchased')">
        <mat-icon>{{ flagIcon(formGroup.value.is_purchased) }}</mat-icon><span>{{ flagText(formGroup.value.is_purchased) }}</span>
      </button>
    </div>

    <div class="filter-item">
      <label class="filter-label" for="flt-limit" title="Nombre de modèles ramenés par la recherche">Nb&nbsp;rép.</label>
      <select id="flt-limit" class="custom-select limit-select" formControlName="limit" (change)="onSearch()">
        @for (val of limitsValue; track val) {
          <option [value]="val">{{ val }}</option>
        }
      </select>
    </div>

    <!-- En MODALE, les créations sont des liens target="_blank" : la vente en cours vit SOUS la fenêtre, la quitter la perdrait. -->
    <div class="toolbar-actions">

      @if (dialogRef) {
        <a class="btn-inline btn-create" [href]="newFlatProductHref" target="_blank" rel="noopener"
          [matTooltip]="NEW_FLAT_HINT" matTooltipClass="tooltip-multiline">
          <mat-icon>add</mat-icon><span>Produit</span>
        </a>
        <a class="btn-inline btn-create btn-create-tpl" [href]="newTemplateHref" target="_blank" rel="noopener"
          [matTooltip]="NEW_TPL_HINT" matTooltipClass="tooltip-multiline">
          <mat-icon>add</mat-icon><span>Modèle</span>
        </a>
      } @else {
        <a class="btn-inline btn-create" [routerLink]="['/sales/product-tpl']" [queryParams]="{ kind: 'flat' }"
          [matTooltip]="NEW_FLAT_HINT" matTooltipClass="tooltip-multiline">
          <mat-icon>add</mat-icon><span>Produit</span>
        </a>
        <a class="btn-inline btn-create btn-create-tpl" [routerLink]="['/sales/product-tpl']" [queryParams]="{ kind: 'generic' }"
          [matTooltip]="NEW_TPL_HINT" matTooltipClass="tooltip-multiline">
          <mat-icon>add</mat-icon><span>Modèle</span>
        </a>
      }

      <span class="actions-sep"></span>

      <!-- Plus aucune recherche ne part seule (arrivée, croix) : ce bouton est le geste principal, il doit se voir. -->
      <button type="button" class="btn-inline btn-search" (click)="onSearch()">
        <mat-icon [class.spinning]="loadingProducts">refresh</mat-icon><span>Rechercher</span>
      </button>
      <!-- Une seule croix : en modale elle ferme, en pleine page elle vide les filtres sans relancer de recherche. -->
      @if (dialogRef) {
        <button type="button" class="btn-inline btn-ghost" aria-label="Fermer" title="Fermer"
          [mat-dialog-close]="">
          <mat-icon>close</mat-icon>
        </button>
      } @else {
        <button type="button" class="btn-inline btn-clear" aria-label="Effacer"
          title="Vider les filtres" (click)="onCancel()">
          <mat-icon>clear</mat-icon>
        </button>
      }
    </div>

  </div>

  <!-- Un modèle par ligne, ses déclinaisons en lignes filles s'il en affiche plusieurs ; la couleur dit la nature, la légende la nomme. -->
  <div class="table-card">

    <div class="table-header-bar">
      <div class="table-title">
        <mat-icon>list_alt</mat-icon>
        <span>Liste des produits</span>
        <span class="badge-count" matTooltip="Modèles ramenés par la recherche">{{ productsTpl.length }}</span>
        <span class="badge-count products" matTooltip="Produits affichés, déclinaisons comprises">{{ productCount }}</span>
      </div>

      <div class="legend">
        <span class="legend-chip flat_product" matTooltip="Modèle à produit unique : la ligne EST le produit">À plat</span>
        <span class="legend-chip template_product" matTooltip="Modèle générique : choisir une déclinaison ci-dessous">Modèle</span>
        <span class="legend-chip specific_product" matTooltip="Déclinaison d'un modèle générique">Spécifique</span>
        <span class="legend-chip config_product" matTooltip="Article configurable (cuf de configuration)">Configurable</span>
      </div>
    </div>

    <div class="table-products" [style.grid-template-columns]="gridTemplateColumns">

      <!-- Entête collante -->
      <div class="product-line entete">
        @for (col of displayedColumnsInfo; track col[0]) {
          <div [class]="'cell ' + col[2]" [matTooltip]="colHint(col)" matTooltipHideDelay="500"
            matTooltipClass="tooltip-multiline" role="columnheader" tabindex="0"
            [attr.aria-sort]="col[3] === undefined ? 'none' : (col[3] ? 'ascending' : 'descending')"
            (click)="onSortClick(col)" (keydown.enter)="onSortClick(col)"
            style="cursor: pointer;">
            <span class="sort-arrow">{{ col[3] === undefined ? '' : (col[3] === true ? '&#8593;' : '&#8595;') }}</span> {{ col[1] }}
          </div>
        }
      </div>

      @for (productTpl of productsTpl; track productTpl.id; let isEven = $even) {

        <!-- Ligne de MODÈLE. À une seule déclinaison affichée, elle vaut le produit lui-même
             et se choisit ; à plusieurs, elle n'est qu'un entête (curseur interdit). -->
        <a (click)="onClickRow(productTpl, $event)" [attr.tabindex]="dialogRef ? 0 : null" (keydown.enter)="onClickRow(productTpl, $any($event))"
          [routerLink]="dialogRef ? null : (((productTpl.lnk_products?.length ?? 0) === 1) ? ['/sales/product', productTpl.lnk_products[0].id] : ['/sales/product-tpl', productTpl.id])"
          [class]="'product-line unstyled-link ' + (((productTpl.lnk_products?.length ?? 0) === 1) ? (isConfigurableProduct(productTpl.lnk_products[0]) ? 'config_product' : 'flat_product') : 'template_product') + (isEven ? ' even' : ' odd') + (dialogRef ? ' dialog' : '')">
          @for (col of displayedColumnsInfo; track col[0]) {
            <div [class]="'cell ' + col[2]">
              @if (col[0] === 'is_sold') {
                @if ((productTpl?.lnk_products?.length ?? 0) === 1) {
                  <mat-icon [class]="productTpl.lnk_products[0]?.is_sold ? 'flag success' : 'flag error'">{{ productTpl.lnk_products[0]?.is_sold ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                }
              } @else if (col[0] === 'is_purchased') {
                @if ((productTpl?.lnk_products?.length ?? 0) === 1) {
                  <mat-icon [class]="productTpl.lnk_products[0]?.is_purchased ? 'flag success' : 'flag error'">{{ productTpl.lnk_products[0]?.is_purchased ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                }
              } @else if (col[0] === 'id') {
                <span class="id-tpl">{{ productTpl.id }}</span>
                <span class="id-product">@if ((productTpl?.lnk_products?.length ?? 0) === 1) { {{ productTpl.lnk_products[0]?.id }} }</span>
              } @else if (col[0] === 'name') {
                @if ((productTpl?.lnk_products?.length ?? 0) === 1 && isConfigurableProduct(productTpl.lnk_products[0])) {
                  <mat-icon class="config-icon">settings</mat-icon>
                }
                <span [title]="productTpl.name || ''">{{ getNestedProperty(productTpl, col[0]) || '-' }}</span>
              } @else if (col[0] === 'price_taxi' || col[0] === 'refs') {
                @if ((productTpl?.lnk_products?.length ?? 0) === 1) {
                  @if (col[0] === 'price_taxi') {
                    {{ productTpl.lnk_products[0]?.[col[0]] || '-' }}
                  } @else {
                    <!-- Références libres : elles peuvent dépasser la piste, d'où l'infobulle native -->
                    <span [title]="refsOf(productTpl.lnk_products[0])">{{ productTpl.lnk_products[0]?.partnbloc || '-' }}<span class="separator">&nbsp;|&nbsp;</span>{{ productTpl.lnk_products[0]?.partnbsup || '-' }}<span class="separator">&nbsp;|&nbsp;</span>{{ productTpl.lnk_products[0]?.partnbman || '-' }}</span>
                  }
                }
              } @else if (col[0] === 'baseuom/unitpriceuom') {
                {{ productTpl.lnk_baseuom?.name || '-' }}<span class="separator">&nbsp;|&nbsp;</span>{{ productTpl.lnk_unitpriceuom?.name || '-' }}
              } @else if (col[0].startsWith('lnk_cufs') && (productTpl?.lnk_products?.length ?? 0) === 1) {
                {{ getNestedProperty(productTpl.lnk_products[0], col[0]) || '-' }}
              } @else {
                {{ getNestedProperty(productTpl, col[0]) || '-' }}
              }
            </div>
          }
        </a>

        <!-- Déclinaisons : seulement quand le modèle en affiche plusieurs -->
        @if ((productTpl?.lnk_products?.length ?? 0) > 1) {
          @for (product of productTpl.lnk_products; track product.id) {
            <a (click)="onClickRow(product, $event)" [routerLink]="dialogRef ? null : ['/sales/product', product.id]"
              [attr.tabindex]="dialogRef ? 0 : null" (keydown.enter)="onClickRow(product, $any($event))"
              [class]="'product-line unstyled-link ' + (isConfigurableProduct(product) ? 'config_product' : 'specific_product')"
              id="{{ 'product_' + product.id }}">
              @for (col of displayedColumnsInfo; track col[0]) {
                <div [class]="'cell ' + col[2]">
                  @if (col[0] === 'id') {
                    <span class="id-tpl"></span>
                    <span class="id-product">{{ product.id }}</span>
                  } @else if (col[0] === 'is_sold' || col[0] === 'is_purchased') {
                    <mat-icon [class]="getNestedProperty(product, col[0]) ? 'flag success' : 'flag error'">{{ getNestedProperty(product, col[0]) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  } @else if (col[0] === 'name') {
                    <span [title]="product.name || ''">{{ getNestedProperty(product, col[0]) || '-' }}</span>
                  } @else if (col[0] === 'lnk_partner_manuf.name') {
                    {{ product.attributestring }}
                    @for (attr of product.attributes; track attr; let last = $last) {
                      {{ attr.pav_name }}@if (!last) { • }
                    }
                  } @else if (col[0] === 'price_taxi') {
                    {{ product[col[0]] || '-' }}
                  } @else if (col[0] === 'refs') {
                    <span [title]="refsOf(product)">{{ product.partnbloc || '-' }}<span class="separator">&nbsp;|&nbsp;</span>{{ product.partnbsup || '-' }}<span class="separator">&nbsp;|&nbsp;</span>{{ product.partnbman || '-' }}</span>
                  } @else if (col[0] === 'baseuom/unitpriceuom') {
                  } @else {
                    {{ getNestedProperty(product, col[0]) || '-' }}
                  }
                </div>
              }
            </a>
          }
        }
      }

      @if (loadingProducts) {
        <div class="loading-products" style="grid-column: 1 / -1;">
          <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary"></mat-progress-spinner>
          <span>Recherche des produits…</span>
        </div>
      } @else if (searchDropped) {
        <div class="empty-products" style="grid-column: 1 / -1;">
          <mat-icon class="empty-icon">search_off</mat-icon>
          <div class="empty-title">Recherche interrompue</div>
          <div class="empty-subtitle">Un critère a changé pendant la recherche&nbsp;: sa réponse, qui portait sur les anciens critères, a été écartée. Entrée dans Nom, Code-barres ou Réf.&nbsp;fournisseur, ou le bouton Rechercher, relance la recherche.</div>
        </div>
      } @else if (searchLaunched && productsTpl.length === 0) {
        <div class="empty-products" style="grid-column: 1 / -1;">
          <mat-icon class="empty-icon">inventory_2</mat-icon>
          <div class="empty-title">Aucun produit</div>
          <div class="empty-subtitle">Aucun article ne répond à ces filtres&nbsp;: retirez un critère ou passez Vendable et Achetable à «&nbsp;Tous&nbsp;»&nbsp;; le numéro d'un produit y mène directement.</div>
        </div>
      }

    </div>
  </div>
</div>
